module.exports = __webpack_public_path__ + "static/media/staffenter_logo.619d5e91.png";